import { useQuery } from "react-query";

import { emailContentQueryKeys } from "./queryKeys";
import useApiHelper from "../../services/useApiHelper";
import { IEmailContent } from "../../models/emailContent/EmailContent";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";

export function useEmailContent(agencyId?: string, templateId?: string) {
  const { get } = useApiHelper();

  const emailContent = useQuery({
    queryKey: emailContentQueryKeys.byTemplateId(
      agencyId ?? "",
      templateId ?? ""
    ),
    queryFn: () =>
      get(
        //TODO: UPDATE THIS URL
        `/emailtemplate/${templateId}/contents/${agencyId}`
      ) as unknown as IDefaultResponseWithData<IEmailContent>,
    refetchOnWindowFocus: false,
    enabled: !!templateId || !!agencyId,
  });

  return {
    emailContent,
  };
}
